import type { KeyboardShortcutDefinition } from './types';

export const CHORD_TIMEOUT_MS = 1500;

export const keyboardShortcutsRegistry: KeyboardShortcutDefinition[] = [
  {
    category: 'app',
    id: 'app.focusSearch',
    i18nKey: 'shortcuts.app.focusSearch',
    mac: 'Primary+K',
    windows: 'Primary+K',
  },
  {
    category: 'app',
    id: 'app.openShortcutsHelp',
    i18nKey: 'shortcuts.app.openShortcutsHelp',
    mac: 'Primary+/',
    windows: 'Primary+/',
  },
  {
    category: 'create',
    id: 'create.openMenu',
    i18nKey: 'shortcuts.create.openMenu',
    mac: 'ctrl+n',
    windows: 'alt+n',
  },
  {
    category: 'create',
    id: 'create.folder',
    i18nKey: 'shortcuts.create.folder',
    mac: ['ctrl+c', 'f'],
    windows: ['alt+c', 'f'],
  },
  {
    category: 'create',
    id: 'create.uploadFile',
    i18nKey: 'shortcuts.create.uploadFile',
    mac: ['ctrl+c', 'u'],
    windows: ['alt+c', 'u'],
  },
  {
    category: 'create',
    id: 'create.uploadFolder',
    i18nKey: 'shortcuts.create.uploadFolder',
    mac: ['ctrl+c', 'i'],
    windows: ['alt+c', 'i'],
  },
  {
    category: 'create',
    id: 'create.word',
    i18nKey: 'shortcuts.create.word',
    mac: ['ctrl+c', 't'],
    windows: ['alt+c', 't'],
  },
  {
    category: 'create',
    id: 'create.excel',
    i18nKey: 'shortcuts.create.excel',
    mac: ['ctrl+c', 's'],
    windows: ['alt+c', 's'],
  },
  {
    category: 'create',
    id: 'create.powerpoint',
    i18nKey: 'shortcuts.create.powerpoint',
    mac: ['ctrl+c', 'p'],
    windows: ['alt+c', 'p'],
  },
  {
    category: 'create',
    id: 'create.note',
    i18nKey: 'shortcuts.create.note',
    mac: ['ctrl+c', 'n'],
    windows: ['alt+c', 'n'],
  },
  {
    category: 'create',
    id: 'create.secret',
    i18nKey: 'shortcuts.create.secret',
    mac: ['ctrl+c', 'k'],
    windows: ['alt+c', 'k'],
  },
  {
    category: 'create',
    id: 'create.secretCard',
    i18nKey: 'shortcuts.create.secretCard',
    mac: ['ctrl+c', 'r'],
    windows: ['alt+c', 'r'],
  },
  {
    category: 'create',
    id: 'create.secretIdentity',
    i18nKey: 'shortcuts.create.secretIdentity',
    mac: ['ctrl+c', 'd'],
    windows: ['alt+c', 'd'],
  },
  {
    category: 'create',
    id: 'create.secretSshKey',
    i18nKey: 'shortcuts.create.secretSshKey',
    mac: ['ctrl+c', 'h'],
    windows: ['alt+c', 'h'],
  },
  {
    category: 'create',
    id: 'create.secretCustom',
    i18nKey: 'shortcuts.create.secretCustom',
    mac: ['ctrl+c', 'm'],
    windows: ['alt+c', 'm'],
  },
  {
    category: 'file',
    id: 'file.open',
    i18nKey: 'shortcuts.file.open',
    mac: 'enter',
    windows: 'enter',
  },
  {
    category: 'file',
    id: 'file.openNewTab',
    i18nKey: 'shortcuts.file.openNewTab',
    mac: 'Primary+enter',
    windows: 'Primary+enter',
  },
  {
    category: 'file',
    id: 'file.rename',
    i18nKey: 'shortcuts.file.rename',
    mac: 'f2',
    windows: 'f2',
  },
  {
    category: 'file',
    id: 'file.share',
    i18nKey: 'shortcuts.file.share',
    mac: 'Primary+Alt+A',
    windows: 'Primary+Alt+A',
  },
  {
    category: 'file',
    id: 'file.move',
    i18nKey: 'shortcuts.file.move',
    mac: 'Primary+Alt+M',
    windows: 'Primary+Alt+M',
  },
  {
    category: 'file',
    id: 'file.favorite',
    i18nKey: 'shortcuts.file.favorite',
    mac: 'Primary+Alt+S',
    windows: 'Primary+Alt+S',
  },
  {
    category: 'file',
    id: 'file.delete',
    i18nKey: 'shortcuts.file.delete',
    mac: 'delete',
    windows: 'delete',
  },
  {
    category: 'file',
    id: 'file.copyLink',
    i18nKey: 'shortcuts.file.copyLink',
    mac: 'Primary+Alt+L',
    windows: 'Primary+Alt+L',
  },
  {
    category: 'file',
    id: 'file.createShortcut',
    i18nKey: 'shortcuts.file.createShortcut',
    mac: 'Primary+Alt+R',
    windows: 'Primary+Alt+R',
  },
  {
    category: 'file',
    id: 'file.details',
    i18nKey: 'shortcuts.file.details',
    mac: ['alt+v', 'd'],
    windows: ['alt+v', 'd'],
  },
  {
    category: 'file',
    id: 'file.download',
    i18nKey: 'shortcuts.file.download',
    mac: 'Primary+Alt+D',
    windows: 'Primary+Alt+D',
  },
  {
    category: 'file',
    id: 'file.publicLink',
    i18nKey: 'shortcuts.file.publicLink',
    mac: 'Primary+Alt+P',
    windows: 'Primary+Alt+P',
  },
  {
    category: 'file',
    id: 'file.setPassword',
    i18nKey: 'shortcuts.file.setPassword',
    mac: 'Primary+Alt+Shift+P',
    windows: 'Primary+Alt+Shift+P',
  },
  {
    category: 'file',
    id: 'file.aiSummary',
    i18nKey: 'shortcuts.file.aiSummary',
    mac: 'Primary+Alt+Shift+A',
    windows: 'Primary+Alt+Shift+A',
  },
  {
    category: 'file',
    id: 'file.tags',
    i18nKey: 'shortcuts.file.tags',
    mac: 'Primary+Alt+T',
    windows: 'Primary+Alt+T',
  },
  {
    category: 'view',
    id: 'nav.toggleGridList',
    i18nKey: 'shortcuts.view.toggleGridList',
    mac: ['alt+v', 'l'],
    windows: ['alt+v', 'l'],
  },
  {
    category: 'navigation',
    id: 'nav.focusSidebar',
    i18nKey: 'shortcuts.nav.focusSidebar',
    mac: ['alt+g', 'n'],
    windows: ['alt+g', 'n'],
  },
  {
    category: 'navigation',
    id: 'nav.focusMain',
    i18nKey: 'shortcuts.nav.focusMain',
    mac: ['alt+g', 'f'],
    windows: ['alt+g', 'f'],
  },
  {
    category: 'navigation',
    id: 'nav.focusDetails',
    i18nKey: 'shortcuts.nav.focusDetails',
    mac: ['alt+g', 'd'],
    windows: ['alt+g', 'd'],
  },
  {
    category: 'navigation',
    id: 'nav.focusUploadDrawer',
    i18nKey: 'shortcuts.nav.focusUploadDrawer',
    mac: ['alt+g', 'u'],
    windows: ['alt+g', 'u'],
  },
  {
    category: 'selection',
    id: 'selection.selectAll',
    i18nKey: 'shortcuts.selection.selectAll',
    mac: 'Primary+A',
    windows: 'Primary+A',
  },
  {
    category: 'selection',
    id: 'selection.clear',
    i18nKey: 'shortcuts.selection.clear',
    mac: 'escape',
    windows: 'escape',
  },
  {
    category: 'selection',
    id: 'selection.toggle',
    i18nKey: 'shortcuts.selection.toggle',
    mac: 'Shift+ ',
    windows: 'Shift+ ',
  },
  {
    category: 'selection',
    id: 'selection.moveFocusUp',
    i18nKey: 'shortcuts.selection.moveFocusUp',
    mac: 'Primary+arrowup',
    windows: 'Primary+arrowup',
  },
  {
    category: 'selection',
    id: 'selection.moveFocusDown',
    i18nKey: 'shortcuts.selection.moveFocusDown',
    mac: 'Primary+arrowdown',
    windows: 'Primary+arrowdown',
  },
  {
    category: 'selection',
    id: 'selection.moveFocusLeft',
    i18nKey: 'shortcuts.selection.moveFocusLeft',
    mac: 'Primary+arrowleft',
    windows: 'Primary+arrowleft',
  },
  {
    category: 'selection',
    id: 'selection.moveFocusRight',
    i18nKey: 'shortcuts.selection.moveFocusRight',
    mac: 'Primary+arrowright',
    windows: 'Primary+arrowright',
  },
  {
    category: 'selection',
    id: 'selection.extendUp',
    i18nKey: 'shortcuts.selection.extendUp',
    mac: 'Shift+arrowup',
    windows: 'Shift+arrowup',
  },
  {
    category: 'selection',
    id: 'selection.extendDown',
    i18nKey: 'shortcuts.selection.extendDown',
    mac: 'Shift+arrowdown',
    windows: 'Shift+arrowdown',
  },
  {
    category: 'selection',
    id: 'selection.extendLeft',
    i18nKey: 'shortcuts.selection.extendLeft',
    mac: 'Shift+arrowleft',
    windows: 'Shift+arrowleft',
  },
  {
    category: 'selection',
    id: 'selection.extendRight',
    i18nKey: 'shortcuts.selection.extendRight',
    mac: 'Shift+arrowright',
    windows: 'Shift+arrowright',
  },
];

/** Help modal entries: one row per id (first binding wins for duplicates like focusSearch). */
export function getKeyboardShortcutsForHelp(): KeyboardShortcutDefinition[] {
  const seen = new Set<string>();
  return keyboardShortcutsRegistry.filter((entry) => {
    if (entry.showInHelp === false) return false;
    if (seen.has(entry.id)) return false;
    seen.add(entry.id);
    return true;
  });
}

export function getKeyboardShortcutById(
  id: KeyboardShortcutDefinition['id'],
): KeyboardShortcutDefinition | undefined {
  return keyboardShortcutsRegistry.find((entry) => entry.id === id);
}
